import axiosSetup from "../utils/axiosSetup";

export const getUserRouteData = async (userId: string, date?: string) => {
  try {
    const response = await axiosSetup.get(
      `/attendanceApp/live-location/${userId}`,
      {
        params: { date },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching user route:", error);
    throw error;
  }
};

export const getMonthlyReport = async (
  month: number,
  year: number,
  userId?: string
) => {
  try {
    const params: Record<string, any> = { month, year };
    if (userId) {
      params.userId = userId;
    }
    const response = await axiosSetup.get("/attendanceApp/monthly", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Get monthly report error:", error);
    throw error;
  }
};

export const getAllTodayAttendance = async (search?: string, date?: string) => {
  try {
    const params: Record<string, any> = {};
    if (search) params.search = search;
    if (date) params.date = date;
    const response = await axiosSetup.get("/attendanceApp/all-today", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Get all today attendance error:", error);
    throw error;
  }
};

export const getAttendanceMetadata = async () => {
  try {
    const response = await axiosSetup.get("/attendance-metadata");
    return response.data;
  } catch (error) {
    console.error("Error fetching attendance metadata:", error);
    throw error;
  }
};

export const getCurrentUserMonthlyReport = async (
  month: number,
  year: number
) => {
  try {
    const params = { month, year };
    const response = await axiosSetup.get(
      "/attendanceApp/current-user-monthly-record",
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Get current user monthly report error:", error);
    throw error;
  }
};

export const apiAddHolidays = async (
  holidays: { date: string; name: string }[]
) => {
  try {
    const res = await axiosSetup.post("/attendance-metadata/holidays", {
      holidays,
    });
    return res.data.data;
  } catch (error: any) {
    console.error("Error adding holidays:", error);
    throw error.response?.data || error;
  }
};

export const apiAddDepartments = async (departments: string[]) => {
  try {
    const res = await axiosSetup.post("/attendance-metadata/departments", {
      departments,
    });
    return res.data.data;
  } catch (error: any) {
    console.error("Error adding departments:", error);
    throw error.response?.data || error;
  }
};

export const apiAddDesignations = async (designations: string[]) => {
  try {
    const res = await axiosSetup.post("/attendance-metadata/designations", {
      designations,
    });
    return res.data.data;
  } catch (error: any) {
    console.error("Error adding designations:", error);
    throw error.response?.data || error;
  }
};

export const apiAddEmploymentStatuses = async (
  employmentStatuses: string[]
) => {
  try {
    const res = await axiosSetup.post(
      "/attendance-metadata/employment-statuses",
      { employmentStatuses }
    );
    return res.data.data;
  } catch (error: any) {
    console.error("Error adding employment statuses:", error);
    throw error.response?.data || error;
  }
};

export const apiDeleteHolidays = async (dates: string[]) => {
  try {
    const res = await axiosSetup.post("/attendance-metadata/delete/holidays", {
      dates,
    });
    return res.data.data;
  } catch (error: any) {
    console.error("Error deleting holidays:", error);
    throw error.response?.data || error;
  }
};

export const apiDeleteDepartments = async (departments: string[]) => {
  try {
    const res = await axiosSetup.post(
      "/attendance-metadata/delete/departments",
      { departments }
    );
    return res.data.data;
  } catch (error: any) {
    console.error("Error deleting departments:", error);
    throw error.response?.data || error;
  }
};

export const apiDeleteDesignations = async (designations: string[]) => {
  try {
    const res = await axiosSetup.post(
      "/attendance-metadata/delete/designations",
      { designations }
    );
    return res.data.data;
  } catch (error: any) {
    console.error("Error deleting designations:", error);
    throw error.response?.data || error;
  }
};

export const apiDeleteEmploymentStatuses = async (
  employmentStatuses: string[]
) => {
  try {
    const res = await axiosSetup.post(
      "/attendance-metadata/delete/employment-statuses",
      { employmentStatuses }
    );
    return res.data.data;
  } catch (error: any) {
    console.error("Error deleting employment statuses:", error);
    throw error.response?.data || error;
  }
};
